import { Select, Spin } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getToken } from '../../utils/getToken';

const { Option } = Select;

const ClientOptions = ({ onChange, value }) => {
  const [clientOptions, setClientOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = getToken();

  const fetchClient = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        'http://admin.defconinnovations.com/crmapi/GetCustomer/',
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      );

      // Check if response.data is an array before setting state
      if (Array.isArray(response.data)) {
        setClientOptions(response.data);
      } else {
        console.error('Expected array but received:', response.data);
        setClientOptions([]);
      }
    } catch (error) {
      console.error('Error fetching clients:', error);
      setClientOptions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClient();
  }, []);

  // For debugging
  /* useEffect(() => {
    console.log('Client options:', clientOptions);
  }, [clientOptions]); */

  // If the data is still loading, show a loading indicator
  if (loading) {
    return (
      <Select
        placeholder="Loading clients..."
        loading
        notFoundContent={<Spin size="small" />}
      />
    );
  }

  // If no data was found, provide a fallback option
  if (!clientOptions || clientOptions.length === 0) {
    return (
      <Select placeholder="No clients found">
        <Option value="no_clients">No clients available</Option>
      </Select>
    );
  }
  return (
    <Select
      placeholder="Select a client"
      onChange={onChange}
      value={value}
      style={{ width: '100%' }}
    >
      {clientOptions.map(client => (
        <Option key={client.id} value={client.id}>
          {client.name}
        </Option>
      ))}
    </Select>
  );
};

export default ClientOptions;
